import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  chessBoard,
  ChessboardFun,
} from '../../shared/functions/chessboardMain';
import {
  AIdifficulty,
  AiPlayedMove,
  changeMode,
  highlightLastMove,
  highlightNextMove,
  moveBlock,
  resetChess,
  undoMove,
  updateBoard,
} from '../../shared/functions/onDrop';
import { joinGame, socket } from '../../shared/helpers/socketio';
import { PlayBoardService } from '../../shared/services/play-board.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { FriendsService } from '../../shared/services/friends.service';
import { game } from '../../shared/functions/chess';
import { LoginPopupComponent } from '../../shared/login-popup/login-popup.component';
import { ProfileService } from '../../shared/services/profile.service';
import { ToastrService } from 'ngx-toastr';
import { Chess } from '../../shared/js';
import { Themeservice } from '../../core/services/theme.service';
import { PieceIconPipe } from '../../shared/pipes/piece-icon.pipe';
import { FormsModule } from '@angular/forms';
import { CommonServiceService } from '../../shared/services/common-service.service';
import { debounceTime, distinctUntilChanged, of, switchMap, tap } from 'rxjs';
import { StockfishService } from '../../shared/services/stockfish.service';
import { removeDots } from '../../shared/functions/highlightpossiblemoves';
import { DecryptionService } from '../../shared/services/decryption.service';
@Component({
  selector: 'app-play',
  standalone: true,
  templateUrl: './play.component.html',
  styleUrl: './play.component.scss',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LoginPopupComponent,
    PieceIconPipe,
    FormsModule,
  ],
})
export class PlayComponent
  implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy
{
  @ViewChild('moveScroll') private moveScrollContainerHorizontal: any;
  @ViewChild('moveScrollContainerVertical')
  private moveScrollContainerVertical: any;
  protected gameSelect!: FormGroup;
  protected multiPlayer!: FormGroup;
  blacksideTimer: string = '';
  whitesideTimer: string = '';
  friendUrl: any;
  AIgame = true;
  displayStyle = 'none';
  AIlostgamePopup = 'none';
  gamelinkCreate: boolean = false;
  gameoverPopup = 'none';
  opponentWaiting: boolean = false;
  challengeWaiting: boolean = false;
  loginuserData: any;
  multiplayerGameDetails: any;
  computerModeSelect: boolean = false;
  selectMode: any;
  chessBoardShow: boolean = false;
  challangeMode: boolean = false;
  friendsList: any;
  challengeFriend: string = '';
  playerMode: boolean = true;
  challangeData: any;
  gameMode = false;
  modalDisplayStyle!: boolean;
  userrating: any;
  switchState: boolean = true;
  showAdvancedOptions = false;
  computerGameData: string[] = [];
  playerSide!: boolean;
  type: string = 'R';
  chessboard: any;
  game = new Chess();
  currentTheme: any = this.theme;
  messages: string[] = [
    'The computer wins! Better luck next time!',
    'Game Over! The computer has outsmarted you this time.',
    'Victory for the computer! Try again to reclaim your glory.',
    'The computer prevails! Challenge it again for a rematch.',
    'Well played! The computer takes the win this round.',
    'The computer wins this battle! Ready for another round?',
    'Defeated by the computer! Practice makes perfect!',
    'Game over! The computer claims victory.',
    'The computer wins! Can you beat it next time?',
  ];
  minRating: any;
  maxRating: any;
  minutes: any;
  increment: any;
  visibility: string = 'public';
  moveSounds: boolean = false;
  selectedMessage: string = '';
  formattedTime: string = '10 Min';
  formattedMode: string = 'rapid';
  formattedImage: string = '/assets/icon-image/rapid-img.svg';
  errorMessage!: string;
  DailyMode = [
    {
      image: '/assets/icon-image/daily-img.svg',
      mode: 'daily',
      time: '1 Day',
    },
    {
      image: '/assets/icon-image/daily-img.svg',
      mode: 'daily',
      time: '7 Day',
    },
  ];
  RapidMode = [
    {
      image: '/assets/icon-image/rapid-img.svg',
      mode: 'rapid',
      time: '10 Min',
    },
    {
      image: '/assets/icon-image/rapid-img.svg',
      mode: 'rapid',
      time: '15 Min',
    },
    {
      image: '/assets/icon-image/rapid-img.svg',
      mode: 'rapid',
      time: '30 Min',
    },
  ];
  BlitzMode = [
    {
      image: '/assets/icon-image/blitz-img.svg',
      mode: 'blitz',
      time: '3 Min',
    },
    {
      image: '/assets/icon-image/blitz-img.svg',
      mode: 'blitz',
      time: '3 Min | 2',
    },
    {
      image: '/assets/icon-image/blitz-img.svg',
      mode: 'blitz',
      time: '5 Min',
    },
  ];
  BulletMode = [
    {
      image: '/assets/icon-image/bullet-img.svg',
      mode: 'bullet',
      time: '1 Min',
    },
    {
      image: '/assets/icon-image/bullet-img.svg',
      mode: 'bullet',
      time: '1 Min | 1',
    },
    {
      image: '/assets/icon-image/bullet-img.svg',
      mode: 'bullet',
      time: '2 Min',
    },
  ];

  computerModeData = [
    {
      image: '../../../../assets/chesspieces/alpha/wP.png',
      darkImage: '../../../../assets/chesspieces/alpha/bP.png',
      mode: 'Beginner',
      difficulty: 0,
    },
    {
      image: '../../../../assets/chesspieces/alpha/wB.png',
      darkImage: '../../../../assets/chesspieces/alpha/bB.png',
      mode: 'Intermediate',
      difficulty: 1,
    },
    {
      image: '../../../../assets/chesspieces/alpha/wN.png',
      darkImage: '../../../../assets/chesspieces/alpha/bN.png',
      mode: 'Advanced',
      difficulty: 2,
    },
    {
      image: '../../../../assets/chesspieces/alpha/wQ.png',
      darkImage: '../../../../assets/chesspieces/alpha/bQ.png',
      mode: 'Master',
      difficulty: 4,
    },
    {
      image: '../../../../assets/chesspieces/alpha/wK.png',
      darkImage: '../../../../assets/chesspieces/alpha/bK.png',
      mode: 'Grandmaster',
      difficulty: 5,
    },
  ];

  searchControl = new FormControl();
  results: any = [];
  currentPage = 1;
  query: string = '';
  isLoading = false;
  hasMoreResults = true;
  currentIndex!: number;
  constructor(
    private friendlist: FriendsService,
    private playService: PlayBoardService,
    private fb: FormBuilder,
    private ratingData: ProfileService,
    private router: Router,
    private toastr: ToastrService,
    private theme: Themeservice,
    private toasterapi: CommonServiceService,
    private decryptionApi: DecryptionService
  ) {
    this.toasterapi.challangeRequest$.subscribe((res) => {
      if (res.rejectReq) {
        this.rejectRequest();
      }
    });
    localStorage.removeItem('gameIdreponse');
    this.selectRandomMessage();
  }

  ngOnInit(): void {
    this.searchControl.valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((query) => {
          this.query = query;
          this.currentPage = 1;
          this.results = [];
          this.hasMoreResults = true;
          return this.loadResults();
        })
      )
      .subscribe((data) => {
        const decrypt = this.decryptionApi.decrypt(data.payload);
        const jsondecrpt = JSON.parse(decrypt);
        this.results = jsondecrpt;
      });
    this.loginuserData = JSON.parse(
      localStorage.getItem('loggedInUser') || '{}'
    );
    this.gameSelect = this.fb.group({
      gameType: ['multiplayer'],
      time: ['10min'],
      playedAS: ['R'],
    });
    this.multiPlayer = this.fb.group({
      time: ['10min'],
    });

    this.AIgameOver();
  }

  ngAfterViewInit(): void {
    ChessboardFun();
    resetChess();
    this.PlayerRating();

    socket.on('startGame', (data: any) => {
      let gamedetails = JSON.parse(
        localStorage.getItem('gameIdreponse') || '{}'
      );

      if (gamedetails.wonBY) {
        return;
      }

      if (this.friendUrl) {
        this.router.navigate(['play', this.friendUrl]);
      }

      if ((this.challengeWaiting = true)) {
        return;
      }
    });

    socket.on('matched', (data: any) => {
      localStorage.setItem('gameIdreponse', JSON.stringify(data));
      this.multiplayerGameDetails = data;
      if (this.multiplayerGameDetails) {
        this.router
          .navigate(['play', this.multiplayerGameDetails?.gameId])
          .then(() => {
            // window.location.reload();
          });
      }
    });
  }

  ngAfterViewChecked() {
    this.scrollToCurrentMove(this.moveScrollContainerHorizontal);
    this.scrollToCurrentMove(this.moveScrollContainerVertical);
  }

  ngOnDestroy() {
    // socket.disconnect();
  }

  mainMenu() {
    this.opponentWaiting = false;
    this.challangeMode = false;
    this.gamelinkCreate = false;
    this.chessBoardShow = false;
    this.computerModeSelect = false;
    this.gameMode = false;
    this.playerMode = true;
    this.selectMode = undefined;
    updateBoard();
    resetChess();
    highlightLastMove();
    AIdifficulty(this.selectMode);
  }

  makeRandomMove() {
    var possibleMoves = this.game.moves();
    if (this.game.isGameOver()) {
      this.chessboard.start();
      this.game.reset();
    }
    var randomIdx = Math.floor(Math.random() * possibleMoves.length);
    this.game.move(possibleMoves[randomIdx]);
    this.chessboard.position(this.game.fen());
    if (!this.chessBoardShow) {
      setTimeout(() => {
        this.makeRandomMove();
      }, 800);
    }
  }

  updateTime(): void {
    this.minutes = Math.max(1, Math.min(60, this.minutes || 1));

    const minutesStr = this.minutes ? `${this.minutes} Min` : '';
    const incrementStr = this.increment || '';

    if (incrementStr && incrementStr !== '0') {
      this.formattedTime = `${minutesStr} | ${incrementStr}`;
    } else {
      this.formattedTime = minutesStr;
    }

    const modeMappings = {
      bullet: { mode: 'bullet', image: '/assets/icon-image/bullet-img.svg' },
      blitz: { mode: 'blitz', image: '/assets/icon-image/blitz-img.svg' },
      rapid: { mode: 'rapid', image: '/assets/icon-image/rapid-img.svg' },
    };

    const modeObj =
      this.minutes < 3
        ? modeMappings.bullet
        : this.minutes <= 9
        ? modeMappings.blitz
        : modeMappings.rapid;

    this.formattedMode = modeObj.mode;
    this.formattedImage = modeObj.image;
  }

  toggleSwitch(checked: any) {
    this.switchState = checked.checked;
  }

  rejectRequest() {
    this.challengeWaiting = false;
    this.challangeMode = true;
    this.toastr.error('Challange Rejected.');
  }

  selectModeValue(data: any) {
    this.formattedTime = data.time;
    this.formattedMode = data.mode;
    this.formattedImage = data.image;
    this.minutes = '';
    this.increment = '';
  }

  PlayerRating() {
    const UserId = localStorage.getItem('loggedInUser');
    if (UserId) {
      this.ratingData.playerRating().subscribe({
        next: (res: any) => {
          const decrypt = this.decryptionApi.decrypt(res.payload);
          const jsondecrpt = JSON.parse(decrypt);
          this.userrating = jsondecrpt.ratings;
        },
      });
    }
  }

  AIgameOver() {
    AiPlayedMove.subscribe((res) => {
      if (res && this.selectMode !== undefined) {
        this.computerGameData = this.parsePGN(game.pgn());
        this.currentIndex = this.computerGameData.length;
        if (this.selectMode?.mode !== 'Beginner') {
          if (game.turn() == 'b') {
            setTimeout(() => {
              this.getBestMove(game.fen(), this.selectMode?.difficulty);
            }, 1000);
          }
        } else {
          var possibleMoves = game.moves();
          var randomIdx = Math.floor(Math.random() * possibleMoves.length);
          if (game.turn() == 'b') {
            setTimeout(() => {
              game.move(possibleMoves[randomIdx]);
              chessBoard.position(game.fen());
              updateBoard();
              this.computerGameData = this.parsePGN(game.pgn());
              this.currentIndex = this.computerGameData.length;
            }, 1000);
          }
        }

        if (game.isGameOver() || game.isCheckmate()) {
          this[game.turn() === 'b' ? 'AIlostgamePopup' : 'gameoverPopup'] =
            'block';
        }
      }
    });
  }

  getBestMove = async (fen: string, level: number) => {
    const stockfishService = new StockfishService();
    try {
      const bestMove = await stockfishService.evaluatePosition(fen, level);
      game.move(bestMove);
      chessBoard.position(game.fen());
      updateBoard();
      this.computerGameData = this.parsePGN(game.pgn());
      this.currentIndex = this.computerGameData.length;
      if (game.isGameOver() || game.isCheckmate()) {
        this[game.turn() === 'b' ? 'AIlostgamePopup' : 'gameoverPopup'] =
          'block';
      }
      return bestMove;
    } catch (error) {
      throw error;
    }
  };

  toggleAdvancedOptions(): void {
    this.showAdvancedOptions = !this.showAdvancedOptions;
  }

  parsePGN(pgn: string): string[] {
    const movesArray: string[] = [];
    const moves = pgn.split(/\d+\./).slice(1);

    for (let move of moves) {
      const moveSequence = move.trim().split(/\s+/);
      for (let singleMove of moveSequence) {
        if (singleMove.trim() !== '') {
          movesArray.push(singleMove);
        }
      }
    }

    return movesArray;
  }

  gameTypeSelect() {
    const UserId = localStorage.getItem('loggedInUser');
    if (UserId !== null) {
      this.modalDisplayStyle = false;
      this.computerModeSelect = false;
      this.playerMode = false;
      this.challangeMode = true;
      this.friendlist.findfriend('').subscribe({
        next: (res: any) => {
          const decrypt = this.decryptionApi.decrypt(res.payload);
          const jsondecrpt = JSON.parse(decrypt);

          this.friendsList = jsondecrpt;
        },
      });
    } else {
      this.modalDisplayStyle = true;
    }
  }

  friendCallenge(data: string) {
    this.challengeFriend = data;
    this.playerSide = true;
    this.gameMode = true;
    this.challangeMode = false;
  }

  startgame() {
    this.challangeMode = false;
    this.chessBoardShow = false;
    this.computerModeSelect = false;
    this.gameMode = false;
    const ratingModeMap: any = {
      bullet: this.userrating?.bullet?.last?.rating,
      blitz: this.userrating?.blitz?.last?.rating,
      rapid: this.userrating?.rapid?.last?.rating,
    };

    const ratings = ratingModeMap[this.formattedMode];

    if (this.minRating == undefined && this.maxRating == undefined) {
      this.minRating = '';
      this.maxRating = '';
    }
    const formData = {
      gameMode: this.formattedMode,
      time: this.formattedTime,
      playedAS: this.type,
      rating: ratings,
      ratedGame: this.switchState,
      minRating: this.minRating,
      maxRating: this.maxRating,
      visibility: this.visibility,
    };

    if (this.challengeFriend === 'null') {
      this.playService.createData(formData).subscribe((res) => {
        const decrypt = this.decryptionApi.decrypt(res.payload);
        const jsondecrpt = JSON.parse(decrypt);
        this.friendUrl = jsondecrpt.gameId;
        if (res) {
          this.gamelinkCreate = true;
          joinGame(jsondecrpt.gameId);
        }
      });
    } else {
      this.challengeWaiting = true;
      const challangeData = {
        username: this.challengeFriend,
        gameMode: this.formattedMode,
        time: this.formattedTime,
        sentChallange: this.loginuserData.username,
        rating: ratings,
        playedAS: this.type,
        ratedGame: this.switchState,
        minRating: this.minRating,
        maxRating: this.maxRating,
        visibility: this.visibility,
      };

      socket.emit('challange', challangeData);
    }
  }

  reset() {
    resetChess();
  }

  undo() {
    undoMove();
  }

  changemode() {
    changeMode();
  }

  closegameOver() {
    this.gameoverPopup = 'none';
    AiPlayedMove.next(false);
  }

  closeAIlostgame() {
    this.AIlostgamePopup = 'none';
    AiPlayedMove.next(false);
  }

  closePopup() {
    this.displayStyle = 'none';
  }

  copyText() {
    const link = `https://chessx.ai/play/${this.friendUrl}`;
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      if (successful) {
        return true;
      }
    } catch (err) {}

    return false;
  }

  sharepopup() {
    this.challengeWaiting = false;
    this.challangeMode = true;
    this.gamelinkCreate = false;
    this.gameSelect.reset();
    const challangeData = {
      username: this.challengeFriend,
      gameMode: this.formattedMode,
      time: this.formattedTime,
      sentChallange: this.loginuserData.username,
      playedAS: this.type,
      ratedGame: this.switchState,
      minRating: this.minRating,
      maxRating: this.maxRating,
      visibility: this.visibility,
    };

    socket.emit('cancelChallange', challangeData.username);
  }

  whatsappLink() {
    const whatsappLink = `https://api.whatsapp.com/send?text=https://chessx.ai/play/${this.friendUrl}`;
    window.location.href = whatsappLink;
  }

  facebookLink() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=https://chessx.ai/play/${this.friendUrl}`;
    window.location.href = facebookLink;
  }

  multiplayerGame() {
    const UserId = localStorage.getItem('loggedInUser');
    if (UserId !== null) {
      this.modalDisplayStyle = false;
      this.playerMode = false;
      this.gameMode = true;
      this.playerSide = false;
    } else {
      this.modalDisplayStyle = true;
    }
  }

  multiplayersumbit() {
    this.challangeMode = false;
    this.chessBoardShow = false;
    this.computerModeSelect = false;
    this.gameMode = false;
    this.opponentWaiting = true;
    const ratingModeMap: any = {
      bullet: this.userrating?.bullet?.last?.rating,
      blitz: this.userrating?.blitz?.last?.rating,
      rapid: this.userrating?.rapid?.last?.rating,
    };

    const ratings = ratingModeMap[this.formattedMode];
    if (this.minRating == undefined && this.maxRating == undefined) {
      this.minRating = '';
      this.maxRating = '';
    }
    const formData = {
      gameMode: this.formattedMode,
      time: this.formattedTime,
      username: this.loginuserData.username,
      rating: ratings,
      playedAS: this.type,
      ratedGame: this.switchState,
      minRating: this.minRating,
      maxRating: this.maxRating,
      visibility: this.visibility,
    };

    localStorage.setItem('moveSounds', JSON.stringify(this.moveSounds));

    socket.emit('joinMatchmaking', formData);
  }

  multiplayerclose() {
    this.loginuserData = JSON.parse(
      localStorage.getItem('loggedInUser') || '{}'
    );
    const formData = {
      gameMode: this.formattedMode,
      time: this.formattedTime,
      username: this.loginuserData.username,
    };

    this.opponentWaiting = false;
    this.playerMode = true;
    socket.emit('cancelMatchMaking', formData);
  }

  validateRatings() {
    if (this.minRating >= this.maxRating) {
      this.errorMessage = 'Maximum rating must be greater than minimum rating.';
    } else {
      this.errorMessage = '';
    }
  }

  computerMode() {
    this.playerMode = false;
    this.challangeMode = false;
    this.computerModeSelect = true;
  }

  modeSelect(data: any) {
    this.selectMode = data;
    AIdifficulty(data);
  }

  chooseMode(data: any) {
    moveBlock('');
    const UserId = localStorage.getItem('loggedInUser');
    if (UserId == null) {
      if (
        data.difficulty === 2 ||
        data.difficulty === 4 ||
        data.difficulty === 5
      ) {
        this.modalDisplayStyle = true;
      } else {
        this.computerGameData = [];
        this.chessBoardShow = true;
        resetChess();
      }
    } else {
      this.computerGameData = [];
      this.chessBoardShow = true;
      resetChess();
    }
  }

  onPlayASChange(e: any) {
    this.type = e.target.value;
  }

  makeFriend() {
    this.router.navigate(['/friends']);
  }

  GetChildData(data: any) {
    this.modalDisplayStyle = data;
  }

  profilememberDetails(username: string) {
    this.router.navigate(['/profile', username]);
  }

  selectRandomMessage(): void {
    const randomIndex = Math.floor(Math.random() * this.messages.length);
    this.selectedMessage = this.messages[randomIndex];
  }

  clearSearch() {
    this.searchControl.setValue('');
    this.results = [];
    this.query = '';
    this.currentPage = 1;
    this.hasMoreResults = true;
  }

  onScroll(event: any) {
    const element = event.target as HTMLElement;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const totalHeight = element.scrollHeight;
    if (!this.hasMoreResults) {
      return;
    }

    if (scrollPosition >= totalHeight - 1 && !this.isLoading) {
      this.loadMore();
    }
  }

  loadMore() {
    this.loadResults().subscribe();
  }

  loadResults() {
    if (!this.query) {
      return of([]);
    }

    this.isLoading = true;
    return this.ratingData.allplayerData(this.query, this.currentPage).pipe(
      tap((data) => {
        const decrypt = this.decryptionApi.decrypt(data.payload);
        const jsondecrpt = JSON.parse(decrypt);
        if (jsondecrpt && jsondecrpt.length) {
          this.results = this.results.concat(jsondecrpt);
          this.currentPage++;
        } else {
          this.hasMoreResults = false;
        }
        this.isLoading = false;
      })
    );
  }

  scrollToCurrentMove(containerRef: ElementRef) {
    if (containerRef) {
      const container = containerRef.nativeElement;
      const selectedMove = container.querySelector('.selected-move');
      if (selectedMove) {
        const containerHeight = container.clientHeight;
        const containerWidth = container.clientWidth;
        const moveHeight = selectedMove.clientHeight;
        const moveWidth = selectedMove.clientWidth;
        const offsetTop = selectedMove.offsetTop - container.offsetTop;
        const offsetLeft = selectedMove.offsetLeft - container.offsetLeft;

        container.scrollTop = offsetTop - containerHeight / 2 + moveHeight / 2;
        container.scrollLeft = offsetLeft - containerWidth / 2 + moveWidth / 2;
      }
    }
  }
}
